export default {
  name: 'CounterController',
  props: {
    min: {
      default: 1,
    },
    started: {
      default: 0,
    },
  },
  data() {
    return {
      amount: this.min,
      price: this.started,
    }
  },
  methods: {
    changeAmount(val) {
      this.amount = Number(val.count)
    },
    setPrice(price) {
      this.price = price
    },
  },
  render() {
    return this.$scopedSlots.default({
      amount: this.amount,
      change: val => this.changeAmount(val),
      setPrice: price => this.setPrice(price),
      price: this.price,
    })
  },
}
